import { TextProvider } from '../TextProvider';
import { formatTimeFromDate } from '../utils/FormateDate';

export class ExpectedDeliveryDateFormatter {
    public static formatDate = (value: string | Date) => {
        const locale = 'no-NB';

        if (value === null) return '';

        const givenDate = typeof value === 'string' ? new Date(value.split('+')[0] || value) : value;
        const todayDate = new Date();
        const difference = ExpectedDeliveryDateFormatter.dateDiffInDays(todayDate, givenDate);

        if (difference === 0) return `${formatTimeFromDate(givenDate.toString())} ${TextProvider.expectedDeliveryDate.today}`;
        if (difference === 1) return `${formatTimeFromDate(givenDate.toString())} ${TextProvider.expectedDeliveryDate.tomorrow}`;

        return givenDate.toLocaleDateString(locale, { month: 'long', day: '2-digit' });
    };

    static dateDiffInDays = (a: Date, b: Date) => {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;

        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    };
}
